const frameUpgradeRE = /^\/profile\/orders\/\d+\/frame-upgrade/;

export const isSignInFrameUpgrade = (
  redirect?: string | string[] | null,
): redirect is string =>
  typeof redirect === 'string' && frameUpgradeRE.test(redirect);
